import { CoreState } from "../state";

import { LimitsModalType, LimitsSummary } from "./limits-reminder.model";

/**
 * @deprecated -[fabric-deprecated] - Use limits-reminder-service from app-account instead.
 * */
export namespace LimitsReminderSelector {
	/**
	 * @deprecated - [fabric-deprecated] - Use AccountAppCommand_INTERNAL.GetLastGameId from app-account instead
	 * */
	export const getLastGameId = (state: CoreState): string | undefined => state.limitsReminder?.lastGameId;
	/**
	 * @deprecated - [fabric-deprecated] - Use AccountAppCommand_INTERNAL.GetLimits from app-account instead
	 * */
	export const getLimits = (state: CoreState): LimitsSummary | undefined => state.limitsReminder?.limitsSummary;
	/**
	 * @deprecated - [fabric-deprecated] - Use AccountAppCommand_INTERNAL.GetLimitsError from app-account instead
	 * */
	export const getLimitsError = (state: CoreState): boolean | undefined =>
		state.limitsReminder?.limitsSummaryFetchError;
	/**
	 * @deprecated - [fabric-deprecated] - Use AccountAppCommand_INTERNAL.GetLimitsReminderType from app-account instead
	 * */
	export const getLimitsReminderType = (state: CoreState): LimitsModalType | undefined =>
		state.limitsReminder?.limitsModalType;
}
